import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  Input,
  InputGroup,
  Button,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { AddWorkSteps } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export default function AddWorkStepModal({
  isOpen,
  toggle,
  workCardId,
  periodId,
  level,
  objId,
}) {
  const [newWorkStepName, setNewWorkStepName] = useState("");
  const queryClient = useQueryClient();
  const postNewWorkSteps = useMutation({ mutationFn: AddWorkSteps });

  const handleCloseModal = () => {
    setNewWorkStepName("");
    toggle();
  };

  const handlePost = () => {
    let workStepResource = {
      workCardId: workCardId,
      workSteps: [{ name: newWorkStepName }],
    };
    postNewWorkSteps.mutate(workStepResource, {
      throwOnError: true,
      onSuccess: () => {
        toast.success("postning lyckad");
        handleCloseModal();
        queryClient.invalidateQueries({ queryKey: ["FetchWorkCardHours", [level, periodId, objId]] });
      },
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
  };

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <ModalHeader>
        <FormattedMessage id="AddWorkStep" />
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={9}>
            <span className="text-warning">
              <FontAwesomeIcon
                icon="triangle-exclamation"
                style={{ marginRight: "0.1rem" }}
              />
            </span>
            <span className="font-italic">
              <FormattedMessage id="ConsiderThatTheWorkcardChangesForEveryone" />
            </span>
          </Col>
        </Row>
        <Row>
          <Col lg={9}>
            <span className="text-warning">
              <FontAwesomeIcon
                icon="triangle-exclamation"
                style={{ marginRight: "0.1rem" }}
              />
            </span>
            <span className="font-italic">
              <FormattedMessage id="DontForgetToCreateWorkStepComponentAfterWorkStep" />
            </span>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col lg={6}>
            <InputGroup>
              <Input
                type="text"
                placeholder="Namn på arbetsmoment"
                onChange={(data) => {
                  setNewWorkStepName(data.target.value);
                }}
              />
            </InputGroup>
          </Col>
        </Row>
        <ModalFooter className="mt-2">
          <Button outline color="secondary" onClick={() => handleCloseModal()}>
            <FormattedMessage id="Cancel" />
          </Button>
          <Button outline color="primary" onClick={() => handlePost()}>
            <FormattedMessage id="Save" />
          </Button>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
}
